import firebase from './firebase';

var db = firebase.firestore();


export default {
    add(payload) {
        return new Promise(resolve => {
            db.collection('fox_locations')
            .add(payload)
            .then((ref)=> {
                resolve(ref.id);
            })
            .catch((err) => {
                console.log(err);
            });
        });
    },
    remove(location) {
        db.collection('fox_locations').doc(location.id).delete();
    },
    get(fox, cb) {
        db.collection('fox_locations').orderBy("time", "desc").onSnapshot((snap) => {
            var path = [];
            snap.forEach((doc) => {
                var data = doc.data();
                data.id = doc.id;
                path.push(data);
            });
            cb(path);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/FoxService.js